import { render, staticRenderFns } from "./Inactivity.vue?vue&type=template&id=fbc0fd58&scoped=true&"
import script from "./Inactivity.vue?vue&type=script&lang=js&"
export * from "./Inactivity.vue?vue&type=script&lang=js&"
import style0 from "./Inactivity.vue?vue&type=style&index=0&id=fbc0fd58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc0fd58",
  null
  
)

export default component.exports